module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAXCAYAAADQpsWBAAAAAXNSR0IArs4c6QAAANRJREFUOBGVlLkKwkAURfM7WmihhQskro1W2ojf5l9ZWtgrCIL7xniuRrBKbi4c0tzDSyYzE4UQ2rCCfuSG8hKUM3gixRJsQJHYswZSrMAOlBPYYo3yXhaR2HUnNigfZJFCYpwKP7HjThxgXGQRTbTFEeWbLHKExJ04ofyQRQqJM4TnR/uKsTtxkUp6rHMlSnN4qU30itmTKEzB/ybKY7iDomXPXj0KQ7iCkv+fKCWg3a5YQpOiv/co18Hf5ZSr4J8nymXYguKdXIr/d4R9YluIhW6jN29HjFMT3e1MAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/arrow-right.png
// module id = mlYB
// module chunks = 1